var Breakpoint = /* @__PURE__ */ ((Breakpoint2) => {
  Breakpoint2["LARGE"] = "large";
  Breakpoint2["SMALL"] = "small";
  return Breakpoint2;
})(Breakpoint || {});
const DEFAULT_BREAKPOINT = "large";
export {
  Breakpoint,
  DEFAULT_BREAKPOINT
};
//# sourceMappingURL=breakpoints.js.map
